import * as THREE from 'three';
import type {
  PointCloudMaterial as PointCloudMaterialType,
  PointCloudOctree as PointCloudOctreeType,
  PointCloudTree as PointCloudTreeType,
  Viewer as PointCloudViewerType,
} from '../types/pointcloud.js';

import { PointCloudMaterial } from '../pointcloud-utils/materials/point-cloud-material.js';
import { PointCloudOctree } from '../pointcloud-utils/point-cloud-octree.js';
import { Renderer } from '../pointcloud-utils/point-cloud-renderer.js';
import { PointCloudTree } from '../pointcloud-utils/point-cloud-tree.js';
import { Viewer } from '../pointcloud-utils/viewer/viewer.js';

export { PointCloudMaterial, PointCloudTree };

export type PointCloudViewer = Viewer;
export type PotreePointCloudOctree = PointCloudOctree;
export type PotreePointCloudMaterial = PointCloudMaterial;
export type PotreePointCloudTree = PointCloudTree;

export type PotreeViewerContract = PointCloudViewerType;
export type PotreePointCloudOctreeContract = PointCloudOctreeType;
export type PotreePointCloudMaterialContract = PointCloudMaterialType;
export type PotreePointCloudTreeContract = PointCloudTreeType;

export interface PotreeRenderer {
  render(scene: THREE.Scene, camera: THREE.Camera, target?: THREE.WebGLRenderTarget | null): void;
}

export function createViewer(container: HTMLElement): PointCloudViewer {
  return new Viewer(container);
}

export function createPointCloudOctree(geometry: unknown): PotreePointCloudOctree {
  return new PointCloudOctree(geometry as never);
}

export function createPointCloudRenderer(renderer: THREE.WebGLRenderer): PotreeRenderer {
  return new Renderer(renderer) as unknown as PotreeRenderer;
}
